module.exports = __webpack_public_path__ + "static/img/head-2.61220f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/head-2.png
// module id = gr6l
// module chunks = 1